import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

import { FeatureDataStateService } from "./feature-data-state.service";

type OwpAccessPwdState = string | unknown[] | null;
type OwpPayloadState = string | Record<string, unknown> | unknown[] | null;

/**
 * OwpStateService
 * --------------------------------------------------------------------
 * OWP-specific reactive state: access password, whether it was
 * selected, generated plugin-input data, and the "edited data" stream
 * (which — for legacy reasons — actually mirrors the OWP data stream
 * in `FeatureDataStateService`, not a separate edited buffer).
 *
 * Public names mirror the legacy `ApiService` API.
 */
@Injectable({ providedIn: "root" })
export class OwpStateService {
  readonly generatePlugInPutData = new BehaviorSubject<OwpPayloadState>("");
  readonly owpAccessPwd = new BehaviorSubject<OwpAccessPwdState>("");
  readonly getowpAccessPwd: Observable<OwpAccessPwdState> = this.owpAccessPwd.asObservable();
  readonly owpPasswordSelected = new BehaviorSubject<boolean>(false);
  readonly getowpPasswordSelected: Observable<boolean> = this.owpPasswordSelected.asObservable();

  /**
   * Buffer for the "edited" OWP payload. NOTE: the paired getter
   * `getowpEditedData` intentionally returns the OWP *data* stream
   * (not this subject) to preserve the pre-refactor behaviour.
   */
  readonly owpEditedData = new BehaviorSubject<OwpPayloadState>("");
  /** Legacy alias: mirrors `FeatureDataStateService.owpdata`. */
  readonly getowpEditedData: Observable<unknown>;

  constructor(private featureData: FeatureDataStateService) {
    this.getowpEditedData = this.featureData.owpdata.asObservable();
  }

  sendOwpAccessPwd(data: OwpAccessPwdState): void {
    this.owpAccessPwd.next(data);
  }
  sendOwpPasswordSelected(data: boolean): void {
    this.owpPasswordSelected.next(data);
  }
  setGeneratePluginOutputData(data: OwpPayloadState): void {
    this.generatePlugInPutData.next(data);
  }
  setowpEditedData(value: OwpPayloadState): void {
    this.owpEditedData.next(value);
  }
}
